// extracted by mini-css-extract-plugin
module.exports = {"long-form":"styles-m__long-form__1ymjm","story-grid":"styles-m__story-grid__2YJh6","story-body":"styles-m__story-body__WLV4T","hero-image":"styles-m__hero-image__1YSME"};